import React from 'react';
import { Card, Badge, Btn, BottomNav, BellIcon, TronzaxLogo } from '../components/SharedComponents';
import C from '../styles/tokens';

const Dashboard = ({ navigate }) => {
  const buyOrders = [
    { id: 'XD73826A9F01', time: 'Today, 11:45 AM',     paid: '₹900',   recv: '10 USDT',    status: 'Completed', statusColor: C.accent },
    { id: 'VE2938NK455',  time: 'Yesterday, 4:12 PM',  paid: '₹1,000', recv: '11.11 USDT', status: 'Completed', statusColor: C.accent },
  ];

  const withdrawals = [
    { id: 'WD9821TRC20', time: 'Today, 11:45 AM', amount: '5.00 USDT',  status: 'Completed', statusColor: C.accent,  statusBg: '#e6faf4' },
    { id: 'WD7719BEP20', time: 'Today',           amount: '12.00 USDT', status: 'Pending',   statusColor: C.warning, statusBg: '#fff8e6' },
  ];

  return (
    <div className="page-wrapper fade-in">

      {/* ── Hero Header ── */}
      <div className="dashboard-hero">
        <div className="blob1" />
        <div className="blob2" />

        {/* Top Bar */}
        <div className="flex justify-between items-start" style={{ position: 'relative' }}>
          <div>
            <div className="flex items-center gap-8 mb-8">
              <div style={{ width: 32, height: 32, borderRadius: 10, background: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <TronzaxLogo size={18} />
              </div>
              <span style={{ color: '#fff', fontWeight: 800, fontSize: 20 }}>Tronzax</span>
            </div>
            <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 13, fontWeight: 500 }}>
              Welcome back, John 👋
            </div>
          </div>
          <button style={{ background: 'rgba(255,255,255,0.15)', border: 'none', borderRadius: 12, width: 40, height: 40, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', backdropFilter: 'blur(8px)' }}>
            <BellIcon />
          </button>
        </div>

        {/* Balance Card */}
        <div className="balance-card">
          <div className="balance-label">Total USDT Balance</div>
          <div className="balance-amount">516.44 <span style={{ fontSize: 18 }}>USDT</span></div>
          <div className="balance-inr">≈ ₹46,480</div>
          <div className="balance-actions">
            <Btn
              onClick={() => navigate('buy')}
              variant="success" size="sm" full
              icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>}
            >Buy USDT</Btn>
            <Btn
              onClick={() => navigate('withdraw')}
              variant="ghost" size="sm" full
              style={{ color: '#fff', border: '1.5px solid rgba(255,255,255,0.3)' }}
              icon={<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="12" y1="5" x2="12" y2="19"/><polyline points="19 12 12 19 5 12"/></svg>}
            >Withdraw</Btn>
          </div>
        </div>

        {/* Stat Cards */}
        <div className="stat-cards">
          {[
            { label: 'Active Orders',       val: '2', color: C.warning },
            { label: 'Pending Withdrawals', val: '1', color: C.danger  },
          ].map(item => (
            <div key={item.label} className="stat-card">
              <div className="stat-card-num" style={{ color: item.color }}>{item.val}</div>
              <div className="stat-card-label">{item.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Content ── */}
      <div className="page-content">

        {/* Recent Buy Orders */}
        <div className="section-header mt-4">
          <span className="section-title">Recent Buy Orders</span>
          <button className="view-all-btn" onClick={() => navigate('account')}>View All ›</button>
        </div>

        <div className="flex-col gap-10 mb-20">
          {buyOrders.map(order => (
            <Card key={order.id} style={{ padding: '14px 16px' }}>
              <div className="order-card-inner">
                <div>
                  <div className="order-id">#{order.id}</div>
                  <div className="order-amount">{order.recv}</div>
                  <div className="order-sub">Paid {order.paid}</div>
                </div>
                <div className="text-right">
                  <Badge color={order.statusColor}>{order.status}</Badge>
                  <div className="order-time">{order.time}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* Recent Withdrawals */}
        <div className="section-header">
          <span className="section-title">Recent Withdrawals</span>
          <button className="view-all-btn" onClick={() => navigate('account')}>View All ›</button>
        </div>

        <div className="flex-col gap-10 mb-24">
          {withdrawals.map(order => (
            <Card key={order.id} style={{ padding: '14px 16px' }}>
              <div className="order-card-inner">
                <div>
                  <div className="order-id">#{order.id}</div>
                  <div className="order-amount">{order.amount}</div>
                </div>
                <div className="text-right">
                  <Badge color={order.statusColor} bg={order.statusBg}>{order.status}</Badge>
                  <div className="order-time">{order.time}</div>
                </div>
              </div>
            </Card>
          ))}
        </div>
      </div>

      <BottomNav active="dashboard" navigate={navigate} />
    </div>
  );
};

export default Dashboard;
